module.exports = __webpack_public_path__ + "media/images/landings/promotion_1/main_img_01-93616c5e5f03f89a0d44de2e866cb578.png";